// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlLambda: "https://s4kgbuk9h9.execute-api.us-east-1.amazonaws.com/qa/-service-laplatahabla-get-parameters",
  urlLambdaSms: "https://s4kgbuk9h9.execute-api.us-east-1.amazonaws.com/qa/-service-laplatahabla-send-sms",
  urlShare: "http://share.bancadigital.com.co"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
